
export const white = '#F5F5F5';

export const grey = '#696969';

export const dark = '#282c34';

export const blue = '#003366';